export default function ScrollToHash() {
  const handleScrollToHash = () => {
    const hash = window.location.hash;
    if (!hash) return;
  
    const target = document.getElementById(hash.slice(1));
    if (!target) return;
  
    const header = document.querySelector("header");
    const stickyScrollNav = document.querySelector<HTMLDivElement>(".js-scroll-nav");
  
    const offset =
      (header?.offsetHeight ?? 0) +
      (stickyScrollNav?.offsetHeight ?? 0) +
      (target.classList.contains("global-bg-padding") ? 0 : 24);
  
    const y =
      target.getBoundingClientRect().top +
      window.scrollY -
      offset;
  
    window.scrollTo({ top: y, behavior: "smooth" });
  };
  
    document.addEventListener("click", (event) => {
        const link = (event.target as HTMLElement).closest<HTMLAnchorElement>("a[href]");
        if (!link) return;

        const href = link.getAttribute("href");
        if (!href) return;

        const url = new URL(href, window.location.href);

        if (
            !url.hash ||
            url.hash === "#" ||
            url.origin !== window.location.origin ||
            url.pathname !== window.location.pathname ||
            url.search !== window.location.search
        ) {
            return;
        }

        event.preventDefault();
        history.pushState(null, "", url.hash);
        handleScrollToHash();
    });

    window.addEventListener("load", handleScrollToHash);
}